import React from 'react';
import { PropTypes } from 'prop-types';
import moment from 'moment';
import { Button, SecurityHelper, AvailabilityTypes } from 'sarsaparilla';
import DetailedAvailabilityActions from 'ui-permit/shared-components/detailed-availability/DetailedAvailabilityActions';

const propTypes = {
  selectedDivision: PropTypes.object,
  selectedStartDate: PropTypes.string,
  selectedEndDate: PropTypes.string,
  selectedDivision2: PropTypes.object,
  selectedStartDate2: PropTypes.string,
  isMultiDestination: PropTypes.bool,
  isEnabled: PropTypes.bool,
  onBookClick: PropTypes.func
};

const defaultProps = {
  isEnabled: false
};

export default class BookNowComponent extends React.Component {
  render() {
    let labels = null;
    let isEnabled = true;
    let validations = [
      this.props.isEnabled,
      moment(this.props.selectedStartDate).isValid()
    ];

    if (this.props.isMultiDestination) {
      validations = [...validations,
        moment(this.props.selectedStartDate2).isValid(),
        moment(this.props.selectedStartDate).isBefore(moment(this.props.selectedStartDate2))
      ];
    }

    validations.some((val) => {
      if (!val) {
        isEnabled = false;
      }
      // This would mean continue until the isEnabled become false or get to the end.
      return !isEnabled;
    });

    if (!this.props.isMultiDestination) {
      labels = (
        <ul>
          <li>{this.props.selectedDivision && this.props.selectedDivision.name}</li>
          <li>
            {this.props.selectedDivision && this.props.selectedStartDate && moment(this.props.selectedStartDate).utc().format('MM/DD/YYYY')}
            {this.props.selectedDivision && this.props.selectedEndDate && (` - ${moment(this.props.selectedEndDate).utc().format('MM/DD/YYYY')}`)}
          </li>
        </ul>
      );
    }
    if (this.props.isMultiDestination) {
      labels = (
        <ul>
          <li>{this.props.selectedDivision && `Entry: ${this.props.selectedDivision.name}`}{this.props.selectedDivision && this.props.selectedStartDate && ` | ${moment(this.props.selectedStartDate).utc().format('MM/DD/YYYY')}`}</li>
          <li>{this.props.selectedDivision2 && `Exit: ${this.props.selectedDivision2.name}`}{this.props.selectedDivision2 && this.props.selectedStartDate2 && ` | ${moment(this.props.selectedStartDate2).utc().format('MM/DD/YYYY')}`}</li>
        </ul>
      );
    }

    const isMobileApp = SecurityHelper.isMobileApp();
    return (
      <DetailedAvailabilityActions>
        <AvailabilityTypes
          legendItems={{
            available: false,
            availableNumber: true,
            walkup: true,
            lottery: false,
            unavailable: true
          }} />
        {!isMobileApp && (
          <div className="selection-information">{labels}</div>
        )}
        <Button
          onClick={this.props.onBookClick}
          disabled={!isEnabled}>Book Now
        </Button>
      </DetailedAvailabilityActions>
    );
  }
}

BookNowComponent.propTypes = propTypes;
BookNowComponent.defaultProps = defaultProps;
